//import { srchv3util } from 'api/srch-v3/srch-v3-util';
import { IfSrchV3PopQueryRow, useApiSrchV3PopQuery } from 'api/srch-v3/useApiSrchV3PopQuery';
import { useHandleSrch } from 'header/header/srchinput/useHandleSrch';
import { SsqImages } from 'images/SsqImages';
import { tsrch } from 'language/i18nkey';
import { fontFamilyMedium } from 'style/fonts';
import styled from 'styled-components';
import { sanitize } from 'util/commonUtils';
import { useRcentSearch } from './useRcentSearch';
import { useZstdSrch } from './useZstdSrch';

export const InputAssistPopQuery = ({}: {}) => {
  const { list } = useApiSrchV3PopQuery(true);
  const { setInput } = useZstdSrch();

  const [, addRecent] = useRcentSearch();
  //const newSearch = useApiNewSrch();
  const { handleSrch: newSearch } = useHandleSrch();

  const handleSearch = (item: IfSrchV3PopQueryRow) => {
    const input = item.word?.trim();
    if (input) {
      setInput(input);
      addRecent(input);
      newSearch(input);
    } else {
      console.error('E empty', input);
    }
  };

  if (!list?.length) return null;

  return (
    <Body>
      <SectionTitle>{tsrch('i18n_search_result_pop_query')}</SectionTitle>
      {/* 다른 섹션과 동일하게 최대 5개까지만 노출 */}
      {list.slice(0, 5).map((item) => (
        <Item key={item.word} onClick={() => handleSearch(item)}>
          <img src={SsqImages.common.icon.relatedSuggestResultIcon()} alt='' />
          <DocTitle dangerouslySetInnerHTML={{ __html: sanitize(item.word ?? '') }} />
        </Item>
      ))}
    </Body>
  );
};

const SectionTitle = styled.div`
  margin-bottom: 0.2rem;
`;

const DocTitle = styled.div`
  flex: 1;
  min-width: 0;
  ${fontFamilyMedium};
  color: #2a2c2f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .search_highlight,
  .search.highlight {
    color: #909fb7;
    background: none !important;
    font-weight: inherit;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  line-height: 3.2rem;
  color: #2a2c2f;
  cursor: pointer;
  /* 호버 하이라이트를 패널 끝까지 꽉 차게 (컨테이너 좌우 패딩 0.8rem 상쇄) */
  margin: 0 -0.8rem;
  padding: 0 0.8rem;

  img {
    flex-shrink: 0;
    vertical-align: middle;
  }

  &:hover {
    background: #407edb1a;
  }
`;

const Body = styled.div`
  box-sizing: border-box;
  border-top: 1px solid #dde2e9;
  width: 100%;
  padding: 0.8rem;
  text-align: left;
  font-size: 1rem;
  color: #909fb7;
`;
